// src/hooks/useBottomSafePadding.js
// 80차 후속: RecruitDetailScreen.js/EventsScreen.js에서 각자 따로 만들다 실수했던
// "하단 고정 버튼이 안드로이드 시스템 내비게이션 바에 가려짐" 버그를 한 곳으로 통일.
//
// 앱 자체 하단탭(useTabScreenOptions, navigation/index.js)이 있는 화면은 탭바 자체가
// 이미 Math.max(32, insets.bottom+8)로 시스템 내비바(3버튼/제스처 둘 다) 여백을 흡수해서,
// 그 안의 고정 버튼은 base 그대로 써야 함(insets를 또 더하면 탭바 위로 붕 뜸).
// 반대로 앱 탭바가 없는 Stack 전용 화면(또는 같은 화면이 Stack으로도 등록된 경우, 예:
// EventsScreen)은 화면 콘텐츠가 기기 맨 아래까지 그려지므로 insets.bottom을 직접 더해야
// 시스템 내비바(3버튼 쪽이 제스처보다 큼)에 안 가려짐 — navigation.getState().type으로
// "지금 이 화면이 탭 안인지"를 실시간 판별해 두 경우 다 정확히 반영.
import { useNavigation } from '@react-navigation/native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

export const useBottomSafePadding = (base = 16) => {
  const navigation = useNavigation();
  const insets = useSafeAreaInsets();
  const isTabScreen = navigation.getState()?.type === 'tab';
  return isTabScreen ? base : base + insets.bottom;
};
